import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box } from '@mui/joy'

const CellStatus = ({ type = 'status', value, classkey }) => {

	const { t, i18n } = useTranslation()
	const getSafeTranslation = (key, fallback = key) => {
		const lang = i18n.resolvedLanguage || i18n.language || 'it';
		const translatedValue = i18n.getResource(lang, 'translation', key);
		return translatedValue !== undefined ? t(key) : fallback;
	};

	return (
		<Box className={'list-element-cell' + (type && ' cell-'+type.toLowerCase().replace(' ','_').replace('/','_'))}>
			{value && <span className={'status' + (classkey ? ' status-'+classkey.replace(' ', '-').toLowerCase() : value ? ' status-'+value.replace(' ', '-').toLowerCase() : '')}>{getSafeTranslation(value, value)}</span>}
		</Box>
	)
}

export default CellStatus
